import React, { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import RoleMaster from "../masters/RoleMaster";
import UserMaster from "../masters/UserMaster";
import CustomerMaster from "../masters/CustomerMasterInfiniteMode";
import { AuthContext } from "../../contexts/AuthContext";
import Dashboard from "../dashboard/Dashboard";
import LocationMaster from "../masters/LocationMaster";
import ContractMaster from "../masters/ContractMaster";
import DisposalIntimationDashboard from "../transaction/DisposalIntimationDashboard";
import EnquiryTenderDashboard from "../transaction/EnquiryTenderDashboard";
import DisposalIntimationReports from "../reports/DisposalIntimationReports";
import EnquiryTenderReports from "../reports/EnquiryTenderReports";
import ItemMaster from "../masters/ItemMaster";
import MaintainBid from "../transaction/MaintainBid";
import FinalizeBid from "../transaction/FinalizeBid";
import UpdateSalesOrder from "../transaction/UpdateSalesOrder";
import ClosedBids from "../reports/ClosedBids";
import { LOGIN_CUSTOMER } from "../../utils/constant";

const MainComp = () => {
  const context = useContext(AuthContext);
  const menuList = context.menuName;
  const userLoginType = context.userType;
  console.log("The menulist", menuList);

  return (
    <Routes>
      {userLoginType === LOGIN_CUSTOMER ? (
        menuList?.includes("Maintain Bid") && (
          <Route exact path="/" element={<MaintainBid />} />
        )
      ) : (
        menuList?.includes("Dashboard") && (
          <Route exact path="/" element={<Dashboard />} />
        )
      )}
      {menuList?.includes("Role & Authorization Master") && (
        <Route exact path="/rolemaster" element={<RoleMaster />} />
      )}
      {menuList?.includes("User Master") && (
        <Route exact path="/usermaster" element={<UserMaster />} />
      )}
      {menuList?.includes("Customer Master") && (
        <Route exact path="/customermaster" element={<CustomerMaster />} />
      )}
      {menuList?.includes("Item Master") && (
        <Route exact path="/itemmaster" element={<ItemMaster />} />
      )}
      {menuList?.includes("Location Master") && (
        <Route exact path="/locationmaster" element={<LocationMaster />} />
      )}
      {menuList?.includes("Contract Master") && (
        <Route exact path="/contractmaster" element={<ContractMaster />} />
      )}
      {menuList?.includes("Disposal Intimation") && (
        <Route exact path="/disposalintimationdashboard" element={<DisposalIntimationDashboard />} />
      )}
      {menuList?.includes("Disposal Intimation Short Close") && (
        <Route exact path="/disposalintimationshortclose" element={<DisposalIntimationDashboard />} />
      )}
      {menuList?.includes("Enquiry/Tender Form") && (
        <Route exact path="/enquirydashboard" element={<EnquiryTenderDashboard />} />
      )}
      {menuList?.includes("Maintain Bid") && (
        <Route exact path="/maintainbid" element={<MaintainBid />} />
      )}
      {menuList?.includes("Finalize Bid") && (
        <Route exact path="/finalizebid" element={<FinalizeBid />} />
      )}
      {menuList?.includes("Update Sales Order") && (
        <Route exact path="/update-sales-order" element={<UpdateSalesOrder />} />
      )}
      {menuList?.includes("Disposal Intimation Reports") && (
        <Route exact path="/disposalintimationreport" element={<DisposalIntimationReports />} />
      )}
      {menuList?.includes("Enquiry/Tender Reports") && (
        <Route exact path="/enquirytenderreport" element={<EnquiryTenderReports />} />
      )}
      {menuList?.includes("Closed Bids") && (
        <Route exact path="/closedbidsreport" element={<ClosedBids />} />
      )}
    </Routes>
  );
};

export default MainComp;
